<div class="ag-cell-label-container" role="presentation">
  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" #menuButton (click)="showColumnMenu()"></span>
  <div ref="eLabel" class="ag-header-cell-label" role="presentation" (click)="showSorted()">
    <y42-icon class="mr-space ag-header-cell-icon" [icon]="params.icon"></y42-icon>
    <span ref="eText" class="ag-header-cell-text" role="columnheader">{{ params.displayName }}</span>
    <span ref="eFilter" class="ag-header-icon ag-filter-icon" *ngIf="state.filterActive"></span>
    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" *ngIf="sorted === 'asc'"></span>
    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" *ngIf="sorted === 'desc'"></span>
    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>
  </div>
</div>
